export class AddFacebookGeneralFeedCommand {
    constructor(public name: string,
                public title: string,
                public tags = 'Visitor Posts',
                public hubName: string,
                public moderate = true,
                public type = 'general',
                public socialName = 'facebook') {
    }
}

export class HubFacebookFeedsCommand {
    constructor(public hubPages: any) {
    }
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/commands/hub/event/add.facebook.general.feed.command.ts